interface StepItemProps {
  number: number;
  title: string;
  description: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

export function StepItem({
  number,
  title,
  description,
  className = '',
  contentClassName = '',
}: StepItemProps) {
  return (
    <div className={`mb-6 flex gap-4 last:mb-0 ${className}`.trim()}>
      <div className="shrink-0">
        <div className="flex size-9 items-center justify-center rounded-full bg-red-50 text-sm font-bold text-red-500">
          {number}
        </div>
      </div>
      <div className={`flex-1 ${contentClassName}`.trim()}>
        <h3 className="mb-1 text-sm font-semibold text-gray-900">{title}</h3>
        <span className="text-sm text-gray-600">{description}</span>
      </div>
    </div>
  );
}
